import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Home } from "./pages/Home";
import { Navbar } from "./pages/Components/Navbar";
import { Footer } from "./pages/Components/Footer";
import { ApplyJob } from "./pages/Apply/index";
import { TnC } from "./pages/tnc";
import { Disabled } from "./pages/Disabled";
import { Maintenance } from "./pages/Maintenance";
import { OexPage } from "./pages/oex/oex";
import { OrderBookDisabled } from "./pages/OrderBook/order-book-disabled";
import PaymentSuccess from "./pages/payment-success";
import PaymentFailure from "./pages/payment-failure";
import WhyTraining from "./pages/why-training";
import WhyFee from "./pages/why-fee";
import TermsConditions from "./pages/terms&con";
import Thankyou from "./pages/Thankyou";
import Contact from "./pages/Contact";
import About from "./pages/About";
import { RegistrationClosed } from "./pages/Sections/RegistrationClosed";
import NotFound from "./pages/NotFound";
import TrainingRegistration from "./pages/Apply/TrainingRegistration";
import { Brt2024 } from "./pages/Sections/Brt2024";
import { Intimations2025 } from "./pages/Sections/Intimations2025";
import { Intimations2023 } from "./pages/Sections/Intimations2023";

interface ValidRoutesProps {}
const ValidRoutes: React.FC<ValidRoutesProps> = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/intimation-letters-2025" element={<Intimations2025 />} />
      <Route path="/intimation-letters-2023" element={<Intimations2023 />} />
      <Route
        path={`/${process.env.REACT_APP_APPLY_ROUTE}`}
        element={<ApplyJob />}
      />
      <Route path="/job" element={<Disabled />} />
      <Route
        path="/training-registration-installment"
        element={<RegistrationClosed />}
      />
      {/* <Route path="/training-registration" element={<RegistrationClosed />} /> */}
      <Route path="/training-registration" element={<TrainingRegistration />} />
      {/* <Route path="/registration" element={<TrainingRegistration />} /> */}
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/payment-failure" element={<PaymentFailure />} />
      <Route path="/why-training" element={<WhyTraining />} />
      <Route path="/why-fee" element={<WhyFee />} />
      <Route path="/terms-conditions" element={<TermsConditions />} />
      <Route path="/thankyou" element={<Thankyou />} />
      <Route path="/book" element={<OrderBookDisabled />} />
      <Route path="/tnc" element={<TnC />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/about" element={<About />} />
      <Route path="/oex" element={<OexPage />} />
      <Route path="/maintenance" element={<Maintenance />} />
      <Route path="/brt-2024" element={<Brt2024 />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

interface RouterHandlerProps {}

export const RouterHandler: React.FC<RouterHandlerProps> = () => {
  return (
    <BrowserRouter>
      <div className="flex flex-col min-h-screen justify-between">
        <Navbar />
        <ValidRoutes />
        <Footer />
      </div>
    </BrowserRouter>
  );
};
